import React, { useEffect, useState, useCallback, useRef } from 'react';
import { playSoundAtom } from '../../State';
import { useRecoilState } from 'recoil';
import joinedSound from './joinedSound.mp3';
import cameraShutterSound from './cameraShutter.mp3';
export default function Sound(props) {
  const [playSound, setPlaySound] = useRecoilState(playSoundAtom);
  const playerRef = useRef();

  useEffect(() => {
    if (playSound == 'play') {
      if (playerRef.current != null) {
        playerRef.current.volume = 0.5;
        playerRef.current.src = joinedSound;
        playerRef.current.play();
        setTimeout(() => {
          setPlaySound('stop');
        }, 1000);
      }
    }

    if (playSound == 'playShutter') {
      if (playerRef.current != null) {
        playerRef.current.volume = 0.8;
        playerRef.current.src = cameraShutterSound;
        playerRef.current.play();
        setTimeout(() => {
          setPlaySound('stop');
        }, 1000);
      }
    }

    return function reset() {
      setPlaySound('stop');
    };
  }, [playSound]);

  return <audio ref={playerRef} src={joinedSound} />;
}
